import React from "react";
import { Modal, Button } from "antd";
import "antd/dist/reset.css";
import "./DataPreviewModal.scss";
import greenDot from "../../assets/icons/UpdatedCheckoutPage/greenDot.svg";
import { FormatUSD } from "../../utilities/string";

export const DataPreviewModal = ({
  data,
  isModalVisible,
  setIsModalVisible,
  onConfirm,
}) => {
  const handleConfirm = () => {
    console.log("Confirmed:", data);
    onConfirm();
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const dataItems = [
    { label: "Account Size", value: FormatUSD(data?.account_size) },
    { label: "Plan Type", value: data?.plan_type },
    { label: "Platform", value: data?.platform?.toUpperCase() },
    {
      label: "Spread Type",
      value: data?.raw_spread ? "Raw spread" : "Standard spread",
    },
    {
      label: "Payout Type",
      value: data?.payout_type?.toLowerCase()?.includes("on demand")
        ? "On Demand"
        : data?.payout_type || "N/A",
    },
    {
      label: "Coupon Applied",
      value:
        data?.coupon_applied === true
          ? "Yes"
          : data?.coupon_applied === false
          ? "No"
          : "N/A",
    },
    {
      label: "Coupon Name",
      value: data?.coupon_name || "N/A",
    },

    {
      label: "Final Price",
      value: FormatUSD(data?.final_price),
    },
  ];

  return (
    <Modal
      title="Purchase Review"
      open={isModalVisible}
      className="custom-modal"
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button key="confirm" type="primary" onClick={handleConfirm}>
          Confirm
        </Button>,
      ]}
    >
      <div className="dropdown-content" onClick={(e) => e.stopPropagation()}>
        {dataItems.map((item, index) => (
          <div key={index} className="dropdown-content_inner">
            <div className="label-container">
              <img src={greenDot} alt="greenDot" />
              <p>{item.label}</p>
            </div>
            <p
              style={{
                color: item.label === "Final Price" ? "#0a4ed8" : "inherit",
                fontWeight: "700",
              }}
            >
              {item.value !== undefined &&
              item.value !== null &&
              item.value !== ""
                ? item.value
                : "N/A"}
            </p>
          </div>
        ))}
      </div>
    </Modal>
  );
};
